import React from "react";
import styled from "styled-components";
import { useQuery } from "@tanstack/react-query";
import { tmdbApi } from "../../services/tmdb";
import { MediaGrid } from "./MediaGrid";
import { LoadingSpinner } from "../common/LoadingSpinner";
import { Sparkles } from "lucide-react";

const SuggestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-6);
`;

const Section = styled.section`
  margin-bottom: var(--spacing-6);
`;

const Title = styled.h2`
  font-size: 1.5rem;
  margin-bottom: var(--spacing-4);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  color: var(--color-text-primary);

  svg {
    color: var(--color-primary);
  }
`;

export interface MovieSuggestionsProps {
  movieId: number;
}

export const MovieSuggestions: React.FC<MovieSuggestionsProps> = ({ movieId }) => {
  const { data: suggestions, isLoading } = useQuery({
    queryKey: ["movie-suggestions", movieId],
    queryFn: () => tmdbApi.getMovieSuggestions(movieId),
    enabled: !!movieId,
  });

  if (isLoading || !suggestions) return <LoadingSpinner />;

  return (
    <SuggestionsContainer>
      <Section>
        <Title>
          <Sparkles size={24} />
          Similar Movies
        </Title>
        <MediaGrid items={suggestions.results.slice(0, 12)} type="movie" />
      </Section>
    </SuggestionsContainer>
  );
};
